module.exports = __webpack_public_path__ + "static/img/logo.5858d4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 118